import { PDFDownloadLink } from "@react-pdf/renderer";
import { MenuItemStyled } from "pages/Orders/components/OrdersTable/components/RowActionsMenu";
import styled from "styled-components";

import { Props } from "../ClearOrderDocument";
import { AbnDocument } from "./AbnDocument";

const StyledPDFDownloadLink = styled(PDFDownloadLink)`
  text-decoration: none;
`;

type DownloadAbnProps = {
  data: Props;
  isLogoLoading?: boolean;
  /** CLE-3015 — a `TourAnchor` value for the menu item (`data-tour`). */
  tourAnchor?: string;
};

export function DownloadAbn({
  data,
  isLogoLoading = false,
  tourAnchor,
}: DownloadAbnProps) {
  // Show loading state while logo is being fetched
  if (isLogoLoading) {
    return (
      <MenuItemStyled
        type="button"
        disabled
        data-neutral="true"
        data-tour={tourAnchor}
        className="flex align-items-center gap-3"
      >
        <i className="pi pi-spin pi-spinner" />
        Loading...
      </MenuItemStyled>
    );
  }

  return (
    <MenuItemStyled
      as={StyledPDFDownloadLink}
      data-neutral="true"
      data-tour={tourAnchor}
      className="flex align-items-center gap-3"
      document={<AbnDocument {...data} />}
      fileName={`abn_document__${new Date().getTime()}.pdf`}
    >
      {({ loading }: { loading: boolean }) =>
        loading ? (
          <>
            <i className="pi pi-spin pi-spinner" />
            Loading...
          </>
        ) : (
          <>
            <i className="pi pi-file" />
            Download ABN
          </>
        )
      }
    </MenuItemStyled>
  );
}
